module.exports = __webpack_public_path__ + "img/three3Red.2b74ca95.jpg";